/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Form from 'react-bootstrap/Form';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import {
  nameLabel,
  corporationNameLabel,
  addressLine1Label,
  addressLine2Label,
  addressLine3Label,
  cityLabel,
  stateLabel,
  zipLabel,
  zip4Label,
  phoneNumberLabel,
  extensionLabel,
  faxNumberLabel,
  emailLabel,
  useCmsContact,
  useDramsContact,
  deleteThisContact,
} from './ConstantData';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  dispatchCheckedValue,
  getContactDifferencesCms,
  getContactDifferencesMfg,
} from '../store/actions';

import { getAllCommentCorrListForCommonPoc } from '../../../System/commentsAndCorrespondence/store/Actions';

const ContactDifferences = ({ checkValues, singleLabeler, getCheckBoxValue }) => {
  const [showComments, setShowComments] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [linkTableName, setLinkTableName] = useState('');

  const dispatch = useDispatch();
  const getCommentsService = () => {
    setShowComments(true);
  };
  // useSelector function
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });

  const contactDifferencesMfg = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contactDifferencesMfg
  );
  const contactDifferencesCms = useSelector(
    (state) => state.sharedState.LabelerDifferencesReducer.contactDifferencesCms
  );
  const [contactDiffValues, setContactDiffValues] = useState(
    contactDifferencesMfg?.labelerDifferencesContactResponseVO
  );
  const [contactDiffValuesCms, setContactDiffValuesCms] = useState(
    contactDifferencesCms?.labelerDifferencesContactResponseVO
  );
  // to handle null entry from contact differences MFG api
  React.useEffect(() => {
    let array = contactDifferencesMfg?.labelerDifferencesContactResponseVO;
    if (array?.length > 0) {
      var arrayCopy = array;
      if (!arrayCopy[0].contactName) {
        arrayCopy[0].contactName = '';
      }
      if (!arrayCopy[0].corpName) {
        arrayCopy[0].corpName = '';
      }
      if (!arrayCopy[0].addrLine1) {
        arrayCopy[0].addrLine1 = '';
      }
      if (!arrayCopy[0].addrLine2) {
        arrayCopy[0].addrLine2 = '';
      }
      if (!arrayCopy[0].addrLine3) {
        arrayCopy[0].addrLine3 = '';
      }
      if (!arrayCopy[0].city) {
        arrayCopy[0].city = '';
      }
      if (!arrayCopy[0].stateCd) {
        arrayCopy[0].stateCd = '';
      }
      if (!arrayCopy[0].zip) {
        arrayCopy[0].zip = '';
      }
      if (!arrayCopy[0].zip4) {
        arrayCopy[0].zip4 = '';
      }
      if (!arrayCopy[0].phoneNum) {
        arrayCopy[0].phoneNum = '';
      }
      if (!arrayCopy[0].phoneExtension) {
        arrayCopy[0].phoneExtension = '';
      }
      if (!arrayCopy[0].faxNum) {
        arrayCopy[0].faxNum = '';
      }
      if (!arrayCopy[0].email) {
        arrayCopy[0].email = '';
      }
    }
    array = arrayCopy;
    setContactDiffValues(array);
  }, [contactDifferencesMfg]);
  // to handle null entry from contact differences cms api
  React.useEffect(() => {
    let array = contactDifferencesCms?.labelerDifferencesContactResponseVO;
    if (array?.length > 0) {
      var arrayCopy = array;
      if (!arrayCopy[0].contactName) {
        arrayCopy[0].contactName = '';
      }
      if (!arrayCopy[0].corpName) {
        arrayCopy[0].corpName = '';
      }
      if (!arrayCopy[0].addrLine1) {
        arrayCopy[0].addrLine1 = '';
      }
      if (!arrayCopy[0].addrLine2) {
        arrayCopy[0].addrLine2 = '';
      }
      if (!arrayCopy[0].addrLine3) {
        arrayCopy[0].addrLine3 = '';
      }
      if (!arrayCopy[0].city) {
        arrayCopy[0].city = '';
      }
      if (!arrayCopy[0].stateCd) {
        arrayCopy[0].stateCd = '';
      }
      if (!arrayCopy[0].zip) {
        arrayCopy[0].zip = '';
      }
      if (!arrayCopy[0].zip4) {
        arrayCopy[0].zip4 = '';
      }
      if (!arrayCopy[0].phoneNum) {
        arrayCopy[0].phoneNum = '';
      }
      if (!arrayCopy[0].phoneExtension) {
        arrayCopy[0].phoneExtension = '';
      }
      if (!arrayCopy[0].faxNum) {
        arrayCopy[0].faxNum = '';
      }
      if (!arrayCopy[0].email) {
        arrayCopy[0].email = '';
      }
    }
    array = arrayCopy;
    setContactDiffValuesCms(array);
  }, [contactDifferencesCms]);
  // C&C functionality
  React.useEffect(() => {
    if (linkTableName === 'CONTACT' && showComments) {
      const newObj = contactDiffValuesCms;
      if (commentsList && commentsList.length > 0) {
        newObj[0].ccCommentsExist = 1;
      } else {
        newObj[0].ccCommentsExist = 0;
      }
      const obj = {
        message: 'SUCESS',
        status: '001',
        labelerDifferencesContactResponseVO: newObj,
      };
      dispatch(getContactDifferencesCms(obj, 'update'));
    } else if (linkTableName === 'CONTACT_MFG' && showComments) {
      const newObj = contactDiffValues;
      if (commentsList && commentsList.length > 0) {
        newObj[0].ccCommentsExist = 1;
      } else {
        newObj[0].ccCommentsExist = 0;
      }
      const obj = {
        message: 'SUCESS',
        status: '001',
        labelerDifferencesContactResponseVO: newObj,
      };
      dispatch(getContactDifferencesMfg(obj, 'update'));
    }
  }, [commentsList]);

  React.useEffect(() => {
    if (contactDiffValuesCms && contactDiffValuesCms.length > 0&&singleLabeler&&singleLabeler.id) {
      if (contactDiffValuesCms[0].corrLinkId) {
          fetchCommentListForCMS(contactDiffValuesCms,singleLabeler);
      }
    }
  }, [contactDiffValuesCms]);
  React.useEffect(() => {
    if (contactDiffValues && contactDiffValues.length > 0&&singleLabeler&&singleLabeler.id) {
      if (contactDiffValues[0].corrLinkId) {
          fetchCommentListForMfg(contactDiffValues,singleLabeler);
      }
    }
  }, [contactDiffValues]);

  const fetchCommentListForCMS = async (contactDiffValuesCms,singleLabeler) => {
    dispatch(getAllCommentCorrListForCommonPoc(null));
    const Obj = contactDiffValuesCms;
    const result = await dispatch(
      getAllCommentCorrListForCommonPoc({
        corrLinkId: Obj[0]?.corrLinkId,
        rowGridPrimaryKey: singleLabeler.id,
        linkTableName: 'CONTACT',
      })
    );
    if (result && result.CommentListData.length > 0) {
      Obj[0].ccCommentsExist = 1;
    } else {
      Obj[0].ccCommentsExist = 0;
    }
    const newObj = {
      message: 'SUCESS',
      status: '001',
      labelerDifferencesContactResponseVO: Obj,
    };
    dispatch(getContactDifferencesCms(newObj, 'update'));
  };
  const fetchCommentListForMfg = async (contactDiffValues,singleLabeler) => {
    dispatch(getAllCommentCorrListForCommonPoc(null));
    const Obj = contactDiffValues;
    const result = await dispatch(
      getAllCommentCorrListForCommonPoc({
        corrLinkId: Obj[0]?.corrLinkId,
        rowGridPrimaryKey: singleLabeler.id,
        linkTableName: 'CONTACT',
      })
    );
    if (result && result.CommentListData.length > 0) {
      Obj[0].ccCommentsExist = 1;
    } else {
      Obj[0].ccCommentsExist = 0;
    }
    const newObj = {
      message: 'SUCESS',
      status: '001',
      labelerDifferencesContactResponseVO: Obj,
    };
    dispatch(getContactDifferencesMfg(newObj, 'update'));
  };

  const onChangeFucntion = (flType, val) => {
    let newVal = _.cloneDeep(getCheckBoxValue) || [];

    if (!_.isEmpty(singleLabeler)) {
      const getOne = !_.isEmpty(newVal)
        ? _.filter(newVal, (l) => l.id === singleLabeler.id)
        : [];
      const changeVal = !_.isEmpty(getOne)
        ? getOne[0]
        : {
            ...singleLabeler,
            ...checkValues,
          };
      changeVal[flType] = val;
      if (flType === 'dramContact') {
        changeVal.useCmsContact = changeVal.useCmsContact
          ? !changeVal.useCmsContact
          : false;
        changeVal.longTermCare = false;
      }
      if (flType === 'useCmsContact') {
        changeVal.dramContact = changeVal.dramContact
          ? !changeVal.dramContact
          : false;
        changeVal.longTermCare = false;
      }
      // Use Manufacturer Invoice Contact uses the MFGINV sequence; otherwise keep CMSINV.
      if (changeVal.dramContact) {
        changeVal.contactSeqNum = !_.isEmpty(contactDiffValues)
          ? contactDiffValues[0]?.contactSeqNum
          : null;
      } else {
        changeVal.contactSeqNum = !_.isEmpty(contactDiffValuesCms)
          ? contactDiffValuesCms[0]?.contactSeqNum
          : null;
      }

      if (!_.isEmpty(getOne)) {
        newVal = _.filter(newVal, (l) => l.id !== singleLabeler.id);
      }
      newVal.push(changeVal);
      if (
        !changeVal.dramContact &&
        !changeVal.useCmsContact &&
        !changeVal.longTermCare
      ) {
        newVal = _.filter(newVal, (l) => l.id !== singleLabeler.id);
      }
    }

    dispatch(dispatchCheckedValue(newVal));
  };

  const isEditableDramContact = React.useMemo(() => {
    if (!_.isEmpty(contactDiffValues)) {
      return !!contactDiffValues[0]?.contactSeqNum;
    }
    return false;
  }, [contactDiffValues]);

  const isEditableCmsContact = React.useMemo(() => {
    if (!_.isEmpty(contactDiffValuesCms)) {
      return !!contactDiffValuesCms[0]?.contactSeqNum;
    }
    return false;
  }, [contactDiffValuesCms]);

  return (
    <div className="tBillPanel custom-check">
      <Form>
        <div className="row">
          <div className="col-6">
            <div className="tab-body custom-check mt-3">
              <fieldset className="custom-fieldset w-100 customFormUi px-4">
                <legend>MFGINV</legend>
                {/* <Form.Group
                  className="mb-3 frr-lab-diff-checkbox-grp"
                  controlId="formBasicCheckbox"
                > */}
                <FormGroup>
                  <FormControlLabel
                    //type="checkbox"
                    id="mfginv-checkbox"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label={useDramsContact}
                    checked={checkValues.dramContact}
                    onChange={() => onChangeFucntion('dramContact', !checkValues.dramContact)}
                    disabled={!isEditableDramContact}
                  />
                  <FormControlLabel
                    //type="checkbox"
                    id="mfginv-deleate-checkbox"
                    label={deleteThisContact}
                    control={<Checkbox color="primary" className="mr-2" />}
                    checked={checkValues.longTermCare}
                    onChange={() => 
                      onChangeFucntion('longTermCare', !checkValues.longTermCare)
                    }
                    disabled={!checkValues.useCmsContact}
                  />
                  </FormGroup>
                {/* </Form.Group> */}
                <div className="row">
                  <div className="col-12 mui-custom-form mx-0 frr-fields-space">
                    {contactDiffValues?.[0]?.contactName &&
                    contactDiffValues?.[0]?.contactName !== '' &&
                    contactDiffValues?.[0]?.contactName.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.contactName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="contact name mfg"
                          label={nameLabel}
                          data-testid="name-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.contactName.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="contact name mfginv"
                        label={nameLabel}
                        data-testid="name-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.contactName
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.corpName &&
                    contactDiffValues?.[0]?.corpName !== '' &&
                    contactDiffValues?.[0]?.corpName.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.corpName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="corp name mfg"
                          label={corporationNameLabel}
                          data-testid="Corporation-name-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.corpName.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="corp name mfginv"
                        label={corporationNameLabel}
                        data-testid="Corporation-name-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.corpName
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.addrLine1 &&
                    contactDiffValues?.[0]?.addrLine1 !== '' &&
                    contactDiffValues?.[0]?.addrLine1.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.addrLine1}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="Address Lines1 Mfg"
                          data-testid="Address-line-mfg"
                          label={addressLine1Label}
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.addrLine1.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="Address Lines1 Mfginv "
                        data-testid="Address-line1-mfginv"
                        label={addressLine1Label}
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.addrLine1
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.addrLine2 &&
                    contactDiffValues?.[0]?.addrLine2 !== '' &&
                    contactDiffValues?.[0]?.addrLine2.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.addrLine2}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="addrLine2mfg"
                          label={addressLine2Label}
                          data-testid="address-line2-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.addrLine2.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="addrLine2mfginv"
                        label={addressLine2Label}
                        data-testid="address-line2-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.addrLine2
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.addrLine3 &&
                    contactDiffValues?.[0]?.addrLine3 !== '' &&
                    contactDiffValues?.[0]?.addrLine3.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.addrLine3}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="addrLine3mfg"
                          label={addressLine3Label}
                          data-testid="address-lines3-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.addrLine3.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="addrLine3mfginv"
                        label={addressLine3Label}
                        data-testid="address-lines3-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.addrLine3
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.city &&
                    contactDiffValues?.[0]?.city !== '' &&
                    contactDiffValues?.[0]?.city.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.city}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="citymfg"
                          label={cityLabel}
                          data-testid="city-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.city.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="citymfginv"
                        label={cityLabel}
                        data-testid="city-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.city
                            : ''
                        }
                      />
                    )}
                    {contactDiffValues?.[0]?.stateCd &&
                    contactDiffValues?.[0]?.stateCd !== '' &&
                    contactDiffValues?.[0]?.stateCd.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.stateCd}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="statemfg"
                          label={stateLabel}
                          data-testid="state-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.stateCd.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="statemfginv"
                        label={stateLabel}
                        data-testid="state-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.stateCd
                            : ''
                        }
                      />
                    )}

                    <TextField
                      id="zipmfginv"
                      label={zipLabel}
                      data-testid="zip-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValues != null &&
                        contactDiffValues.length > 0
                          ? contactDiffValues[0]?.zip
                          : ''
                      }
                    />

                    <TextField
                      id="Zip4mfginv"
                      label={zip4Label}
                      data-testid="zip4-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValues != null &&
                        contactDiffValues.length > 0
                          ? contactDiffValues[0]?.zip4
                          : ''
                      }
                    />

                    <TextField
                      id="phoneNummfginv"
                      label={phoneNumberLabel}
                      data-testid="phone-mfginv"
                      className="mandate-fields"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValues != null &&
                        contactDiffValues.length > 0
                          ? contactDiffValues[0]?.phoneNum
                          : ''
                      }
                    />

                    <TextField
                      id="Extensionmfginv"
                      label={extensionLabel}
                      data-testid="Extension-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValues != null &&
                        contactDiffValues.length > 0
                          ? contactDiffValues[0]?.phoneExtension
                          : ''
                      }
                    />

                    <TextField
                      id="faxNummfginv"
                      label={faxNumberLabel}
                      data-testid="fax-mfginv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValues != null &&
                        contactDiffValues.length > 0
                          ? contactDiffValues[0]?.faxNum
                          : ''
                      }
                    />
                    {contactDiffValues?.[0]?.email &&
                    contactDiffValues?.[0]?.email !== '' &&
                    contactDiffValues?.[0]?.email.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValues?.[0]?.email}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="emailAddrmfg"
                          label={emailLabel}
                          className="mandate-fields"
                          data-testid="email-mfg"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValues != null &&
                            contactDiffValues.length > 0
                              ? `${contactDiffValues[0]?.email.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="emailAddrmfginv"
                        label={emailLabel}
                        className="mandate-fields"
                        data-testid="email-mfginv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValues != null &&
                          contactDiffValues.length > 0
                            ? contactDiffValues[0]?.email
                            : ''
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="comment-sec mt-1">
                  Comments &nbsp;
                  {contactDiffValues != undefined &&
                  contactDiffValues.length > 0 &&
                  contactDiffValues[0].ccCommentsExist &&
                  parseInt(contactDiffValues[0].ccCommentsExist) === 1 ? (
                    <img
                      role="button"
                      onClick={() => {
                        getCommentsService();
                        setCorrLinkId(
                          contactDiffValues != undefined &&
                            contactDiffValues.length > 0
                            ? contactDiffValues[0]?.corrLinkId
                            : ''
                        );
                        setLinkTableName('CONTACT_MFG');
                      }}
                      alt="comment"
                      src={CommentVisibleIcon}
                    />
                  ) : (
                    <img
                      role="button"
                      onClick={() => {
                        if (contactDiffValues[0]?.corrLinkId) {
                          getCommentsService();
                          setCorrLinkId(
                            contactDiffValues != undefined &&
                              contactDiffValues.length > 0
                              ? contactDiffValues[0]?.corrLinkId
                              : ''
                          );
                          setLinkTableName('CONTACT_MFG');
                        }
                      }}
                      alt="comment"
                      src={CommentIcon}
                    />
                  )}
                </div>
              </fieldset>
            </div>
          </div>
          <div className="col-6">
            <div className="tab-body custom-check mt-3">
              <fieldset className="custom-fieldset w-100 customFormUi px-4">
                <legend>CMSINV</legend>
                {/* <Form.Group
                  className="frr-mb-35 frr-lab-diff-checkbox-grp"
                  controlId="formBasicCheckbox"
                > */}
                <FormGroup>
                  <FormControlLabel
                    //type="checkbox"
                    id="cmsinv-checkbox"
                    label={useCmsContact}
                    control={<Checkbox color="primary" className="mr-2" />}
                    checked={checkValues.useCmsContact}
                    disabled={!isEditableCmsContact}
                    onChange={() => onChangeFucntion('useCmsContact', !checkValues.useCmsContact)}
                  />
                  
                  </FormGroup>
                {/* </Form.Group> */}

                <div className="row">
                  <div className="col-12 mui-custom-form mx-0 frr-fields-space ">
                    {contactDiffValuesCms?.[0]?.contactName &&
                    contactDiffValuesCms?.[0]?.contactName !== '' &&
                    contactDiffValuesCms?.[0]?.contactName.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.contactName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="contactnamecms"
                          label={nameLabel}
                          data-testid="name-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.contactName.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="contactnamecmsinv"
                        label={nameLabel}
                        data-testid="name-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != undefined &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.contactName
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.corpName &&
                    contactDiffValuesCms?.[0]?.corpName !== '' &&
                    contactDiffValuesCms?.[0]?.corpName.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.corpName}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="corpName-cms"
                          label={corporationNameLabel}
                          data-testid="Corporation-name-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.corpName.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="corpNamecmsinv"
                        label={corporationNameLabel}
                        data-testid="Corporation-name-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.corpName
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.addrLine1 &&
                    contactDiffValuesCms?.[0]?.addrLine1 !== '' &&
                    contactDiffValuesCms?.[0]?.addrLine1.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.addrLine1}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="Address Lines1 cms"
                          data-testid="Address-line1-cms"
                          label={addressLine1Label}
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.addrLine1.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="Address Lines1 cmsinv"
                        data-testid="Address-line1-cmsinv"
                        label={addressLine1Label}
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.addrLine1
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.addrLine2 &&
                    contactDiffValuesCms?.[0]?.addrLine2 !== '' &&
                    contactDiffValuesCms?.[0]?.addrLine2.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.addrLine2}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="addrLine2cms"
                          label={addressLine2Label}
                          data-testid="address-line2-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.addrLine2.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="addrLine2cmsinv"
                        label={addressLine2Label}
                        data-testid="address-line2-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.addrLine2
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.addrLine3 &&
                    contactDiffValuesCms?.[0]?.addrLine3 !== '' &&
                    contactDiffValuesCms?.[0]?.addrLine3.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.addrLine3}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="addrLine3cms"
                          label={addressLine3Label}
                          data-testid="address-lines3-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.addrLine3.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="addrLine3cmsinv"
                        label={addressLine3Label}
                        data-testid="address-lines3-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.addrLine3
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.city &&
                    contactDiffValuesCms?.[0]?.city !== '' &&
                    contactDiffValuesCms?.[0]?.city.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.city}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="citycms"
                          label={cityLabel}
                          data-testid="city-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.city.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="citycmsinv"
                        label={cityLabel}
                        data-testid="city-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.city
                            : ''
                        }
                      />
                    )}
                    {contactDiffValuesCms?.[0]?.stateCd &&
                    contactDiffValuesCms?.[0]?.stateCd !== '' &&
                    contactDiffValuesCms?.[0]?.stateCd.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.stateCd}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="statecms"
                          label={stateLabel}
                          data-testid="state-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.stateCd.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="statecmsinv"
                        label={stateLabel}
                        data-testid="state-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.stateCd
                            : ''
                        }
                      />
                    )}

                    <TextField
                      id="zipcmsinv"
                      label={zipLabel}
                      data-testid="zip-cmsinv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValuesCms != null &&
                        contactDiffValuesCms.length > 0
                          ? contactDiffValuesCms[0]?.zip
                          : ''
                      }
                    />

                    <TextField
                      id="Zip4cmsinv"
                      label={zip4Label}
                      data-testid="zip4-cmsinv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValuesCms != null &&
                        contactDiffValuesCms.length > 0
                          ? contactDiffValuesCms[0]?.zip4
                          : ''
                      }
                    />

                    <TextField
                      id="phoneNumcmsinv"
                      label={phoneNumberLabel}
                      data-testid="phone-cmsinv"
                      className="mandate-fields"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValuesCms != null &&
                        contactDiffValuesCms.length > 0
                          ? contactDiffValuesCms[0]?.phoneNum
                          : ''
                      }
                    />

                    <TextField
                      id="Extensioncmsinv"
                      label={extensionLabel}
                      data-testid="Extension-cmsinv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValuesCms != null &&
                        contactDiffValuesCms.length > 0
                          ? contactDiffValuesCms[0]?.phoneExtension
                          : ''
                      }
                    />

                    <TextField
                      id="faxNumcmsinv"
                      label={faxNumberLabel}
                      data-testid="fax-cmsinv"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        contactDiffValuesCms != null &&
                        contactDiffValuesCms.length > 0
                          ? contactDiffValuesCms[0]?.faxNum
                          : ''
                      }
                    />
                    {contactDiffValuesCms?.[0]?.email &&
                    contactDiffValuesCms?.[0]?.email !== '' &&
                    contactDiffValuesCms?.[0]?.email.length > 50 ? (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={
                          <Tooltip id="labeler-tooltip">
                            {contactDiffValuesCms?.[0]?.email}
                          </Tooltip>
                        }
                      >
                        <TextField
                          id="emailAddrcms"
                          label={emailLabel}
                          className="mandate-fields"
                          data-testid="email-cms"
                          fullWidth
                          disabled
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            contactDiffValuesCms != null &&
                            contactDiffValuesCms.length > 0
                              ? `${contactDiffValuesCms[0]?.email.substring(
                                  0,
                                  50
                                )}...`
                              : ''
                          }
                        />
                      </OverlayTrigger>
                    ) : (
                      <TextField
                        id="emailAddrcmsinv"
                        label={emailLabel}
                        className="mandate-fields"
                        data-testid="email-cmsinv"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          contactDiffValuesCms != null &&
                          contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.email
                            : ''
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="comment-sec mt-1">
                  Comments &nbsp;
                  {contactDiffValuesCms != undefined &&
                  contactDiffValuesCms.length > 0 &&
                  contactDiffValuesCms[0].ccCommentsExist &&
                  parseInt(contactDiffValuesCms[0].ccCommentsExist) === 1 ? (
                    <img
                      role="button"
                      onClick={() => {
                        getCommentsService();
                        setCorrLinkId(
                          contactDiffValuesCms != undefined &&
                            contactDiffValuesCms.length > 0
                            ? contactDiffValuesCms[0]?.corrLinkId
                            : ''
                        );
                        setLinkTableName('CONTACT');
                      }}
                      alt="comment"
                      src={CommentVisibleIcon}
                    />
                  ) : (
                    <img
                      role="button"
                      onClick={() => {
                        if (contactDiffValuesCms[0]?.corrLinkId) {
                          getCommentsService();
                          setCorrLinkId(
                            contactDiffValuesCms != undefined &&
                              contactDiffValuesCms.length > 0
                              ? contactDiffValuesCms[0]?.corrLinkId
                              : ''
                          );
                          setLinkTableName('CONTACT');
                        }
                      }}
                      alt="comment"
                      src={CommentIcon}
                    />
                  )}
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </Form>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="CONTACT"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={singleLabeler?.id}
        />
      ) : null}
    </div>
  );
};
export default ContactDifferences;
